interface DiagnosisSectionProps {
  currentStep: number;
  answers: {
    annualFee?: string;
    priority?: string;
    occupation?: string;
  };
  onAnswer: (question: string, answer: string) => void;
}

export default function DiagnosisSection({ currentStep, answers, onAnswer }: DiagnosisSectionProps) {
  const questions = [
    {
      id: 'annualFee',
      title: 'Q1. 年会費の希望は？',
      options: [
        { value: 'free', label: '無料がいい', icon: 'ri-money-dollar-circle-line' },
        { value: 'conditional', label: '条件付きならOK', icon: 'ri-checkbox-circle-line' },
        { value: 'premium', label: '特典が良ければ有料でも可', icon: 'ri-vip-crown-line' }
      ]
    },
    {
      id: 'priority',
      title: 'Q2. 何を重視しますか？',
      options: [
        { value: 'cashback', label: '還元率の高さ', icon: 'ri-percent-line' },
        { value: 'approval', label: '審査の通りやすさ', icon: 'ri-shield-check-line' },
        { value: 'benefits', label: '旅行保険・特典', icon: 'ri-flight-takeoff-line' },
        { value: 'points', label: 'ポイ活', icon: 'ri-gift-line' }
      ]
    },
    {
      id: 'occupation',
      title: 'Q3. 現在の職業は？',
      options: [
        { value: 'student', label: '学生', icon: 'ri-graduation-cap-line' },
        { value: 'employee', label: '会社員', icon: 'ri-briefcase-line' },
        { value: 'housewife', label: '主婦', icon: 'ri-home-heart-line' },
        { value: 'parttime', label: 'フリーター／アルバイト', icon: 'ri-user-line' }
      ]
    }
  ];

  const currentQuestion = questions[currentStep];

  if (currentStep >= 3) {
    return null;
  }

  return (
    <section id="diagnosis-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-6">
            {[0, 1, 2].map((step) => (
              <div
                key={step}
                className={`h-2 rounded-full transition-all duration-300 ${
                  step < currentStep
                    ? 'w-12 bg-red-600'
                    : step === currentStep
                    ? 'w-16 bg-red-600'
                    : 'w-12 bg-gray-200'
                }`}
              />
            ))}
          </div>
          <p className="text-sm text-gray-600 mb-2">
            質問 {currentStep + 1} / 3
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            {currentQuestion.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {currentQuestion.options.map((option) => (
            <button
              key={option.value}
              onClick={() => onAnswer(currentQuestion.id, option.value)}
              className="bg-white border-2 border-gray-200 rounded-2xl p-6 hover:border-red-600 hover:shadow-lg transition-all duration-300 text-left group"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center group-hover:bg-red-100 transition-colors">
                  <i className={`${option.icon} text-2xl text-red-600`}></i>
                </div>
                <span className="text-base md:text-lg font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                  {option.label}
                </span>
              </div>
            </button>
          ))}
        </div>

        {currentStep > 0 && (
          <div className="text-center mt-8">
            <button
              onClick={() => window.location.reload()}
              className="text-sm text-gray-600 hover:text-red-600 transition-colors inline-flex items-center gap-2"
            >
              <i className="ri-arrow-left-line"></i>
              <span>最初からやり直す</span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
